<template>
  <v-main>
    <v-card class="idcs-dialog-back fill-height">
      <v-card-actions>
        <v-subheader>
          <i18n path="rec_types.ErrorRecord"></i18n>
        </v-subheader>
        <v-spacer></v-spacer>
        <v-btn icon @click="close" color="error">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-text>
        <v-form ref="form" :lazy-validation="true">
          <v-row>
            <v-col cols="12">
              <v-text-field
                :disabled="!clone"
                v-model="errId"
                :label="$t('field.errorId')+'*'"
                :rules="idRules"
                shaped
                outlined
                background-color="yellow lighten-5"
                color="black"
              ></v-text-field>
            </v-col>
            <template v-for="l in $store.getters['admin/errors_loc']">
              <v-col v-if="item[l]" cols="12" :key="l+'2'">
                <v-text-field
                  v-model="item[l]"
                  shaped
                  outlined
                  background-color="yellow lighten-5"
                  color="black"
                  :label="msgLabel(l)"
                  clearable
                >
                  <template v-slot:append-outer>
                    <v-btn icon @click="delLocale=l,simpleDialog=true">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
            </template>
          </v-row>
          <v-row v-for="msg in newRecs" :key="msg.id">
            <v-col cols="1">
              <v-text-field
                v-model="msg.loc"
                required
                clearable
                shaped
                outlined
                background-color="yellow lighten-5"
                color="black"
                :rules="localeRules"
              ></v-text-field>
            </v-col>
            <v-col cols="1">
              <v-checkbox v-model="msg.glob" label="isGlobal"></v-checkbox>
            </v-col>
            <v-col cols="10">
              <v-text-field
                v-model="msg.msg"
                :label="$t('field.name')"
                :rules="msgRules"
                shaped
                outlined
                background-color="yellow lighten-5"
                color="black"
                clearable
              >
                <template v-slot:append-outer>
                  <v-btn icon @click="delMsg(item.id)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn fab dark color="pink" @click="addMessage">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-alert
                v-model="showAlert"
                border="left"
                colored-border
                type="error"
                elevation="2"
                :dismissible="true"
                transition="fade-transition"
              >{{alertMessage}}</v-alert>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-show="!clone" color="blue darken-1" text @click="errId=''">{{$t('button.clone')}}</v-btn>
        <v-btn color="blue darken-1" text @click="save(true)">{{$t('button.save')}}</v-btn>
      </v-card-actions>
    </v-card>
    <DeleteDialog v-model="simpleDialog" @click:ok="erase" />
  </v-main>
</template>
<script>
import app from "@/app.js";
import DeleteDialog from "@/components/DeleteDialog.vue";

const rec_type = "ErrorRecord";
export default {
  name: "ErrorEditor",
  components: { DeleteDialog },
  props: {
    errorId: { type: String, required: true },
    value: { type: Boolean }
  },
  data() {
    return {
      //clone: false,
      simpleDialog: false,
      delLocale: "",
      showAlert: false,
      alertMessage: "",
      newRecs: [],
      msgRules: [v => !!v || this.$t("error.required")],
      idRules: [v => !!v || this.$t("error.required"), v => this.existsId(v)],
      localeRules: [
        v => !!v || this.$t("error.required"),
        v => (v && v.length == 2) || this.$t("error.length2")
      ],
      item: { ...this.$store.getters["admin/error"](this.errorId) },
      errId: this.errorId.substring(1) | ""
    };
  },
  computed: {
    clone() {
      return this.errorId.substring(1) != this.errId;
    }
  },
  watch: {
    errorId: {
      handler(nw) {
        this.item = { ...this.$store.getters["admin/error"](nw) };
        this.errId = nw.substring(1) | "";
        this.newRecs = [];
      }
    }
  },
  methods: {
    testMessage(l) {
      console.log("testMessage", this.item[l] != undefined, l, this.item[l]);
      return this.item[l] != undefined;
    },
    existsLoc(v) {
      let res = true;
      let loc = "";
      try {
        Object.keys(this.item).forEach(k => {
          loc += "<" + k.toUpperCase() + ">";
        });
        this.newRecs.forEach(e => {
          loc += "<g_" + e.loc.toUpperCase() + ">";
        });
        console.log(loc);
        res = loc.indexOf("<g_" + v.toUpperCase() + ">") == -1;
      } catch (e) {
        console.log(e);
      }
      return res || this.$t("error.locdublicate");
    },
    existsId(v) {
      return (
        !this.clone ||
        !this.$store.getters["admin/isExists"](v) ||
        this.$t("error.dublicate")
      );
    },
    addMessage() {
      this.newRecs.push({
        id: this.newRecs.length,
        loc: "",
        msg: "",
        glob: false
      });
    },
    delMsg(id) {
      this.newRecs.splice(id, 1);
    },
    msgLabel(v) {
      return v.substring(0, 2) == "g_"
        ? this.$t("admin.def_message") + " - " + v.substring(2).toUpperCase()
        : v.toUpperCase();
    },
    erase() {
      app
        .eraseMsg(this.errId, this.delLocale)
        .then(() => {
          this.item.rec_type = rec_type;
          this.$store.commit("admin/remove_message", {
            id: this.errId,
            loc: this.delLocale
          });
          this.$delete(this.item,this.delLocale);
        })
        .catch(error => {
          this.showAlertMessage(error);
        });
      this.simpleDialog = false;
    },
    close() {
      this.$emit("input", false);
    },
    save() {
      if (!this.$refs.form.validate()) return;
      let params = {
        locales: this.$store.getters["admin/errors_loc"],
        record: this.item,
        id: this.errId,
        newrecs: this.newRecs,
        add: this.clone
      };
      this.$store.dispatch("admin/SAVE_ERROR", params).then(() => {
        this.close();
      });
      /*
      app
        .updateMsg(params)
        .then(response => {
          if (response.count) {
            this.item.rec_type = rec_type;
            if (params.add) {
              this.$store.commit("admin/insert_message", {
                id: this.errId,
                rec: this.item,
                list: this.newRecs
              });
              this.$emit("insert", this.item);
            } else {
              this.$store.commit("admin/update_message", {
                id: this.errId,
                rec: this.item,
                list: this.newRecs
              });
              this.$emit("update", this.item);
            }
          }
          this.close();
        })
        .catch(error => {
          this.showAlertMessage(error);
        });
        */
    },
    showAlertMessage(m) {
      if (m.errorMsg) {
        this.alertMessage = this.$t("error." + m.errorMsg);
      } else {
        this.alertMessage = JSON.stringify(m);
      }
      this.showAlert = true;
      setTimeout(() => {
        this.showAlert = false;
      }, 4000);
    }
  }
};
</script>

<style scoped>
</style>